import { BDO, LooseOrderWithPayments, OrderType, OtherOrder, PaymentType, PriceType, TaskType } from 'types';
import { BdoStatement } from './bdo-statement';

interface TaskViewCommon {
	id: number;
	orderId: number;
	nextOrderId: number | null;
	orderType: OrderType;
	type: TaskType;
	client: {
		id: number;
		name: string;
		phone: string;
	};
	date: Date;
	assignedTo: number | null;
	takenAt: Date | null;
	doneAt: Date | null;
	createdAt: Date;
	createdBy: number | null;
}

export interface TaskViewLoose extends TaskViewCommon {
	orderType: OrderType.loose;
	order: LooseOrderWithPayments & {
		bdoStatement?: BdoStatement | null;
		bdoDocumentationComplete?: boolean;
	};
}

export interface TaskViewClassic extends TaskViewCommon {
	orderType: OrderType.classic;
	order: {
		id: number;
		containerSize: string;
		address: string;
		bdo: BDO;
		wasteType: string;
		netPrice: number;
		grossPrice: number;
		priceType: PriceType;
		paymentBy: number | null;
		paymentType: PaymentType;
		paymentDate: Date | null;
		advance: number | null;
		onPlace: boolean;
		bdoCardConfirmedAt?: string | null;
		bdoCardConfirmedBy?: number | null;
		bdoDocumentationComplete?: boolean;
		bdoStatement?: BdoStatement | null;
	};
}

export interface TaskViewOwn extends TaskViewCommon {
	orderType: OrderType.own;
	order: any;
}

export interface TaskViewOther extends TaskViewCommon {
	orderType: OrderType.other;
	order: OtherOrder;
}

export type TaskView = TaskViewLoose | TaskViewClassic | TaskViewOwn | TaskViewOther;
